import React from "react";
import toast from "react-hot-toast";
import { Send } from "lucide-react";

/**
 * After sale details are edited the portals (REA, Collings portal, website)
 * still show the old figures. Saving does not re-publish on its own, since a
 * typo fix in a buyer's email shouldn't re-upload the listing; instead this
 * toast offers the existing "Publish as Sold on Portals" step in one tap.
 */
export const promptPublishSold = (onPublish) =>
  toast(
    (t) => (
      <span className="flex items-center gap-3 text-sm">
        <span className="text-gray-700">Sale details saved. Portals still show the previous details.</span>
        <button
          type="button"
          onClick={() => {
            toast.dismiss(t.id);
            onPublish();
          }}
          className="flex items-center gap-1 whitespace-nowrap rounded-lg bg-[#55C5D0] px-3 py-1.5 text-[11px] font-black uppercase tracking-wider text-white hover:bg-[#4AADB7]"
        >
          <Send className="h-3 w-3" />
          Publish to portals
        </button>
      </span>
    ),
    { duration: 10000, icon: "✅", id: "publish-sold-prompt" },
  );
